import React, { Component } from 'react';
import PlayerForm from './PlayerForm';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <PlayerForm></PlayerForm>
      </div>
    );
  }
}

export default App;
